<template>
  <div>
    <page-header :title="pageTitle" />
    <page-body>
      <el-row>
        <el-form :inline="true" :model="searchForm" ref="searchForm" size="small">
          <el-row>
            <el-col :span="2">
              <el-button type="primary" size="medium" style="margin-left:8px; border-radius: 4px; background: #327dff;" @click="handleSearch">
                查询
              </el-button>
            </el-col>
            <el-col :span="20" sortable="false">
              <el-form-item label="服务器名：" prop="name" class="search-item">
                <el-input v-model="searchForm.name" style="width:200px;" clearable />
              </el-form-item>
              <el-form-item label="服务器IP：" prop="hostname" class="search-item">
                <el-input v-model="searchForm.hostname" style="width:200px;" clearable />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-row>
      <el-row>
        <el-table :data="dataSource" border empty-text="暂无数据">
          <el-table-column label="操作" width="120" align="center">
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="onStopInstance(scope.row)"><img src="../../img/int.png" alt="" style="margin-right:5px;width:16px;height:16px;" /><span>访问</span></el-button>
            </template>
          </el-table-column>
          <el-table-column prop="id" label="ID" width="60px" />
          <el-table-column prop="name" label="服务器名" align="left" width="260">
            <template slot-scope="scope">
              <span>{{ scope.row.name }}</span>
              <span style="margin-left: 10px;color:#e3763e;">(在线用户:{{ scope.row.count || 0 }})</span>
            </template>
          </el-table-column>
          <el-table-column prop="hostname" label="服务器IP"  align="left" width="150" />
          <el-table-column prop="port" label="端口号" width="80"  align="left" />
          <el-table-column prop="os" align="center" label="操作系统" width="150">
            <template slot-scope="scope">
              <el-tag> {{scope.row.os}}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="username" label="用户名" width="120" align="left" />
          <el-table-column prop="protocol" align="center" label="协议类型" width="100">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.protocol == 0">RDP</el-tag>
              <el-tag v-else type="info">VNC</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="is_lock" align="center" label="状态" width="100">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.is_lock == 0">正常</el-tag>
              <el-tag v-else type="info">异常</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" align="left" width="170">
            <template slot-scope="scope">
              {{ formatTimestamp(scope.row.created_time) }}
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注"  align="left" />
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pagination.currentPage"
            :page-sizes="pageSizeList"
            :page-size="pagination.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagination.total" />
      </el-row>
      <div />
    </page-body>
</div>
</template>

<script>
import PageBody from '~/components/PageBody/index.vue'
import PageHeader from '~/components/PageHeader/index.vue'

export default {
  name: 'myspace',
  components: {
    PageHeader,
    PageBody,
  },
  data () {
    return {
      pageTitle: '我的远程桌面资源',
      searchForm: { },
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      dataSource: [],
      timer: null,
      pageSizeList: [10, 20, 50, 100],
    }
  },
  mounted () {
    this.fetchData()
  },
  beforeDestroy () {
    // 在组件销毁前停止定时器
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  },
  methods: {
    // 列表获取
    async fetchData () {
      try {
        if (!this.pagination) {
          console.error('this.pagination is not defined')
          return
        }

        const dataRaw = {
          name: this.searchForm.name,
          hostname: this.searchForm.hostname,
          is_lock: this.searchForm.is_lock,
          account_id: localStorage.getItem('userId'),
          page: this.pagination.currentPage,
          per_page: this.pagination.pageSize,
        }

        const response = await this.$http.get('/rdbackend/user_resources', {
          params: dataRaw,
        })

        const overViewListData = response.data
        this.dataSource = overViewListData.remote_hosts || []
        this.pagination.total = overViewListData.count || 0
        this.pagination.currentPage = overViewListData.page || 1

        // 获取每个服务器的请求接口数量 并10秒刷新
        if (this.timer) {
          clearInterval(this.timer)
          this.timer = null
        } else {
          this.timer = setInterval(() => {
            this.fetchApiCounts()
          }, 10000)
        }
      } catch (error) {
        console.error('There was an error!', error)
      }
    },

    // 获取每个服务器的请求接口数量
    async fetchApiCounts () {
      try {
        const response = await this.$http.get('/rdbackend/connections')
        const res = response.data.data
        for (let i = 0; i < this.dataSource.length; i++) {
          const item = this.dataSource[i]
          for (let j = 0; j < res.length; j++) {
            if (item.name === res[j].name) {
              this.$set(item, 'count', res[j].count)
            }
          }
        }
      } catch (error) {
        console.error('There was an error fetching API counts!', error)
      }
    },

    // 查询
    handleSearch () {
      this.pagination.currentPage = 1
      this.fetchData()
    },

    // 分页
    handleSizeChange (val) {
      // 改变每页显示的条数
      this.pagination.pageSize = val
      this.fetchData(this.pagination.currentPage, this.pagination.pageSize)
    },

    handleCurrentChange (val) {
      // 改变默认的页数
      this.pagination.currentPage = val
      this.fetchData(this.pagination.currentPage, this.pagination.pageSize)
    },

    // 转换时间戳
    formatTimestamp (timestamp) {
      if (timestamp) {
        const date = new Date(timestamp * 1000) // 将秒转换为毫秒
        return date.toLocaleString() // 返回本地化的日期和时间字符串
      }
      return ''
    },

    // 访问实例
    async onStopInstance (row) {
      console.log(row.connection_id)
      try {
        // 使用 await 等待异步请求完成
        const response = await this.$http.get('/rdbackend/gua_url', {
          params: { // 注意这里使用 params 参数传递查询参数
            connection_id: row.connection_id,
          },
        })

        // 获取并使用响应中的 gua_url
        const url = response.data.url
        window.open(url, '_blank')
      } catch (error) {
        // 处理请求失败的情况
        console.error('Error fetching URL:', error)
      }
    },
  },
}
</script>

<style>
body,html{
  min-width: 1280px;
}
.el-table thead{
  color: #333 !important;
  font-weight: bold !important;
}
.el-tag {
  margin-right: 10px;
  margin-bottom: 5px;
}
.el-tag:last-child {
  margin-right: 0;
  margin-bottom: 0;
}
.el-tag{
  border: 0;
  color: #606266;
  background: rgba(0, 0, 0, 0);
}
.el-tag.el-tag--info{
  border: 0;
  color: #606266;
  background: rgba(0, 0, 0, 0);
}
</style>
